<div class="account-picture">
    <img *ngIf="image" [src]="image" />
    <div *ngIf="!image" class="default-image"></div>
</div>